/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import './styles.scss';

export class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      confirmPassword: '',
      passwordMatchError: false,
      emailError: false,
    };
  }

  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleInputChangeLowerCase = (event) => {
    this.setState({ [event.target.name]: event.target.value.toLowerCase() });
  }

  handleSignup = () => {
    this.props.clearUserStatuses();
    this.setState((prevState) => {
      return {
        emailError: !prevState.email.endsWith('dartmouth.edu'),
        passwordMatchError: prevState.password !== prevState.confirmPassword,
      };
    }, () => {
      if (this.state.firstname && this.state.lastname && !this.state.emailError && this.state.password && !this.state.passwordMatchError) {
        const firstname = this.state.firstname.charAt(0).toUpperCase() + this.state.firstname.slice(1);
        const lastname = this.state.lastname.charAt(0).toUpperCase() + this.state.lastname.slice(1);
        this.props.registerUser(this.state.email, this.state.password, firstname, lastname);
      }
    });
  }

  handleResendEmail = () => {
    this.props.clearEmailSent();
    this.props.registerUser(this.state.email, this.state.password, this.state.firstname, this.state.lastname, true);
  }

  render() {
    if (this.props.registerSuccess) {
      return (
        <div className="register-container">
          <h1 className="register-title">Almost There!</h1>
          <p className="register-subtitle">Click the link sent to <b>{this.state.email}</b> to confirm your email. Make sure to check your junk mail folder.</p>
          <p className="register-subtext">Didn&apos;t get anything? </p>
          <button
            type="button"
            className="sign-up-button"
            onClick={this.handleResendEmail}
          >Resend Verification Email
          </button>
          {this.props.resendSuccess ? <p className="success-text">Your verification email has been sent</p> : null}
          {this.props.registerError ? <p className="error-text">There was an error sending your verification email. This could happen if your email has already been verified.</p> : null}
        </div>
      );
    }
    return (
      <div className="register-container" onKeyPress={(e) => { if (e.key === 'Enter') this.handleSignup(); }}>
        <div className="register-subcontainer">
          <h1 className="register-title">Student Sign Up</h1>
          <div className="name-fields-container">
            <div className="register-form-section">
              <input
                className="small-input"
                name="firstname"
                placeholder="First Name"
                value={this.state.firstname}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="register-form-section">
              <input
                className="small-input"
                name="lastname"
                placeholder="Last Name"
                value={this.state.lastname}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="register-form-section">
            {this.state.emailError ? <p className="error-text">Email must end with @dartmouth.edu</p> : null}
            <div className="email-field">
              <input
                className="password-input"
                spellCheck={false}
                name="email"
                value={this.state.email}
                onChange={this.handleInputChangeLowerCase}
                placeholder="Email (example@dartmouth.edu)"
              />
            </div>
          </div>
          <div className="register-form-section">
            <input
              className="password-input"
              name="password"
              type="password"
              placeholder="Password"
              value={this.state.password}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="register-form-section">
            {this.state.passwordMatchError ? <p className="error-text">These passwords do not match</p> : null}
            <input
              className="password-input"
              name="confirmPassword"
              type="password"
              placeholder="Confirm Password"
              value={this.state.confirmPassword}
              onChange={this.handleInputChange}
            />
          </div>
          {this.props.registerError ? <p className="signup-error-text">There was an internal error signing you up. This could happen if your email is already associated with an account.</p> : null}
          <button
            className="sign-up-button"
            type="button"
            onClick={this.handleSignup}
            disabled={
              !this.state.firstname
              || !this.state.lastname
              || !this.state.email
              || !this.state.password
              || !this.state.confirmPassword
            }
          >Sign Up
          </button>
        </div>
      </div>
    );
  }
}

export default Register;
